@for (alert of alerts; track alert) {
    <div [class]="getAlertClass(alert)">
        <mat-icon class="alert-icon">{{ getAlertIcon(alert) }}</mat-icon>
        <span class="alert-message">{{ alert.message }}</span>
        <button class="alert-close" (click)="removeAlert(alert)">
            <mat-icon>close</mat-icon>
        </button>
    </div>
}
